export default __webpack_public_path__ + "static/media/d.6a2f3672.svg";